import React, {useEffect} from 'react';

const Card = (props) => {
    const {
        className,
        inHand,
        played,
        inBita,
        playShuffle = () =>{},
        playCardBita = () =>{},
        playCardSound = () =>{},
        handleClick = () => {}
    } = props;


    useEffect(() => {
        if (inHand) {
            playShuffle()
        }
        if (played) {
            playCardSound()
        }
        if (inBita) {
            playCardBita()
        }
    }, [inHand, played]);

    return <div
        className={`card  ${className}`}
        onClick={() => handleClick()}
    >
        <div className="card--inner">
            <span className="card__back"></span>
            <span className="card__front"></span>
        </div>
    </div>
}

export default Card;